import React, { useEffect, useState } from 'react';
import { Box, Divider } from '@mui/material';
import { JoinDiscordSection } from 'layouts/pages/landing-page/components/sections/JoinDiscordSection';
import { FaqsSection } from 'layouts/pages/landing-page/components/sections/FaqsSection';
import { Footer } from 'layouts/pages/landing-page/components/sections/Footer';
import { landingPageStyles } from 'layouts/pages/landing-page/landingPageStyles';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from 'config/firebase';
import { AnnouncementBanner } from 'layouts/pages/landing-page/components/announcement-bar/AnnouncementBanner';
import NavBar from './components/app-bar/NavBar';
import HeroSection from './components/sections/hero-video/HeroSection';
import CreateImagineSection from './components/sections/create-imagine-section/CreateImagineSection';
import CharacterCharacteristicsSection from './components/sections/characters-characteristics-section/CharacterCharacteristicSection';
import CharactersClothingSection from './components/sections/characters-clothing-section/CharactersClothingSection';
import CharacterNarratorSection from './components/sections/character-narrator-section/CharacterNarratorSection';
import TrustedSection from './components/sections/trusted-section/TrustedSection';
import UnlockNewSection from './components/sections/unlock-new-section/UnlockNewSection';

export default function LandingPage() {
	const [isAnnouncementBarOpen, setIsAnnouncementBarOpen] = useState(true);
	const [bannerData, setBannerData] = useState({});

	const handleAnnouncementBarClick = () => {
		setIsAnnouncementBarOpen(!isAnnouncementBarOpen);
	};

	useEffect(() => {
		const maintenanceBannerStatusUnsubscribe = onSnapshot(
			doc(db, 'websiteBanner', 'data'),
			(docData) => {
				const data = docData?.data();
				if (data) {
					const { status = false } = data;

					if (bannerData?.status !== status) {
						setBannerData(data);
					}
				}
			},
		);
		return () => {
			maintenanceBannerStatusUnsubscribe();
		};
	}, [bannerData?.status]);

	return (
		<Box id="landing-page" sx={{ ...landingPageStyles.mainContainer }}>
			<Box id="nav-bar-with-banner" sx={{ ...landingPageStyles.navBar }}>
				<AnnouncementBanner
					handleAnnouncementBarClick={handleAnnouncementBarClick}
					isAnnouncementBarOpen={isAnnouncementBarOpen}
					bannerData={bannerData}
				/>
				<NavBar />
			</Box>
			<Box id="landing-page-content" sx={{ ...landingPageStyles.contentContainer }}>
				<HeroSection />
				<Box id="create-character-section" sx={{ ...landingPageStyles.sectionContainer }}>
					<CreateImagineSection />
					<CharacterCharacteristicsSection />
					<CharactersClothingSection />
					<CharacterNarratorSection />
					<TrustedSection />
					<UnlockNewSection />
				</Box>
				<Box
					id="create-character-section"
					sx={{
						...landingPageStyles.sectionContainer,
					}}
				>
					<JoinDiscordSection />
					<FaqsSection />
				</Box>

				<Box id="footer-section" sx={{ marginTop: '120px' }}>
					<Divider orientation="horizontal" flexItem sx={{ ...landingPageStyles.dividerStyle }} />
					<Footer />
				</Box>
			</Box>
		</Box>
	);
}
